export const userPrefTypes = {
  TOGGLE_COLUMN: 'TOGGLE_COLUMN',
  SET_ROWS_PER_PAGE: 'SET_ROWS_PER_PAGE',
};
